module.exports = new __parcel__URL__("SPIKEVAX_80777-110-01_PFS.8e858911.jpg").toString();